import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LoadingBarService } from '@ngx-loading-bar/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'vex-progress-bar',
    templateUrl: './progress-bar.component.html',
    styleUrls: ['./progress-bar.component.scss'],
    standalone: false
})
export class ProgressBarComponent implements OnInit {

  constructor(public loader: LoadingBarService) { }

  ngOnInit() {
  }

}
